__turbopack_context__.v({
  "contentHomepage": "ContentHome-module__bYxW9a__contentHomepage",
  "topPadding": "ContentHome-module__bYxW9a__topPadding",
  "zeroMargin": "ContentHome-module__bYxW9a__zeroMargin",
});
